<template>
    <div>
        <div class="bg-blue c-white my-3 py-3">
            <div class="container-fluid">
                <div class="row ">
                    <div class="col">
                        <h2 class="today--heading">
                            <img class="today--heading--logo center-block" src="~__STATIC__/logo_valle_plus.svg" alt="Valle plus logo">
                            <span class="c-yellow" v-text="getTranslation('flexPageTitle')"></span>
                        </h2>
                    </div>
                </div>
            </div>
        </div>

        <banner></banner>

        <div class="ml-3 mr-3">
            <div class="container-fluid">
                <div class="row">
                    <div class="col d-md-flex justify-content-center align-items-center mt-2 mb-4 flex--ticket--type--filter">
                        <h4 class="text-bold c-gray mr-2" v-text="getTranslation('selectOptionLabel')"></h4>
                        <div class="d-flex">
                            <div class="form-check mr-2">
                                <input class="form-check-input" type="radio" id="anyday" name="options" value="false" v-model="isSwitchActive">
                                <label class="form-check-label" for="anyday" v-text="getTranslation('anyDayLabel')"></label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" id="weekdays" name="options" value="true" v-model="isSwitchActive">
                                <label class="form-check-label" for="weekdays" v-text="getTranslation('weekdayOnlyLabel')"></label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ml-3 mr-3 mb-5 d-block d-md-none">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 col-md-3" v-for="(ticket, index) in tickets" :key="ticket.id">
                        <flex-ticket :data="ticket" :show="index === 0" :show-more-button="true"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="ml-3 mr-3 mb-3 d-none d-md-block">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-3" v-for="(ticket, index) in tickets" :key="ticket.id">
                        <flex-ticket :data="ticket" :show="index === 0"/>
                    </div>
                </div>
            </div>
        </div>

        <sticky-footer></sticky-footer>
    </div>
</template>

<script>
    import FlexTicket from '../FlexTicket';
    import * as Actions from '../../store/action-types';
    import siteConfig from '../../mixins/siteConfig';

    export default {
        components: {
            FlexTicket
        },

        mixins: [siteConfig],

        mounted() {
            const params = this.objectifyQueryString(window.location);

            this.$store.dispatch(Actions.setWeekdayOnly, {weekdaysOnly: params.weekdaysOnly == 'true'});
        },

        computed: {
            tickets() {
                return this.$store.getters.flexTickets;
            },

            isSwitchActive: {
                get() {
                    return this.$store.getters.isWeekDaysOnly;
                },

                set() {
                    this.$store.dispatch(Actions.toggleWeekDaysSwitch)
                }
            }
        },
        watch: {
            tickets: {
                immediate: true,
                handler(newTickets) {
                    if (newTickets.length == 0) return
                    const items = [];
                    let i = 1;
                    newTickets.forEach(ticket => {
                        ticket.products.forEach(prod => {
                            items.push({
                                item_name: prod.ticket_name + " " + prod.person,
                                item_id: prod.product_id,
                                price: prod.price,
                                item_brand: "Valle Plus",
                                item_category: ticket.ax_name,
                                item_category2: prod.person,
                                index: i++,
                                quantity:1,
                                currency: "CLP"
                            })
                        })
                    });
                    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                    dataLayer.push({
                        event: "view_item_list",
                        ecommerce: {
                            items: items
                        }
                    });
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Pages/FlexPage.vue